import { ICellRendererParams } from 'ag-grid-community';
import { EmptyStateIcon } from "../../../icon";

interface Props extends ICellRendererParams {
    EmptyLabel: string;
}

const NoRowsOverlay = (props: Props) => {
    return (
        <div className="d-flex">
            <div className="d-flex flex-direction w-p-100 h-p-100 m-auto align-center ">
                <EmptyStateIcon />
                <span className={"mx-auto empty-label h5-regular mt-2"}>{props.EmptyLabel}</span>
            </div>
        </div>
    )
}

export default NoRowsOverlay;